import { memo } from 'react';
import classNames from 'classnames';

import { useLocalization } from 'src/contexts/localization-context';
import type { MausoleumSchemeProps } from './mausoleum-scheme.props';

import './mausoleum-scheme.scss';

const MausoleumScheme = ({
  bankOptions,
  className,
  height,
  onSelectBank,
}: MausoleumSchemeProps) => {
  const { getLocalization } = useLocalization();

  return (
    <section className={classNames('mausoleum-scheme', className)} style={{ height }}>
      <div className="mausoleum-scheme__wrapper">
        <div className="mausoleum-scheme__banks">
          {bankOptions.length ? (
            bankOptions.map((bank) => (
              <button
                key={bank.id}
                className="mausoleum-scheme__bank"
                type="button"
                onClick={() => onSelectBank(bank.id)}
              >
                {bank.value}
              </button>
            ))
          ) : (
            <p className="mausoleum-scheme__empty">{getLocalization('No banks found')}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(MausoleumScheme);
